import type { RailwaySession } from '@cli-types/next-adapter/railway.js'
import { spinner } from '@cli-utils/terminal.js'
import { ensureRailwayAuth } from '@next-adapter/init/railway/auth/ensure-railway-auth.js'
import { ensureRailwayProject } from '@next-adapter/init/railway/project/ensure-railway-project.js'
import { resolveRailwayRunner } from '@next-adapter/init/railway/runner/resolve-railway-runner.js'

export async function createRailwaySession(options: {
  cwd: string
  projectName: string
  interactive: boolean
  workspace?: string
  project?: string
  environment?: string
  env?: NodeJS.ProcessEnv
}): Promise<RailwaySession> {
  const runnerSpinner = spinner()
  runnerSpinner.start('Checking for the Railway CLI')
  const runner = await resolveRailwayRunner()
  runnerSpinner.clear()

  const auth = await ensureRailwayAuth(runner, options.cwd, {
    interactive: options.interactive,
    env: options.env
  })
  if (!auth.authed) {
    const reason =
      auth.reason === 'timeout'
        ? 'Railway sign-in timed out.'
        : auth.reason === 'invalid-token'
          ? 'RAILWAY_TOKEN or RAILWAY_API_TOKEN is invalid.'
          : options.interactive
            ? 'Railway sign-in did not complete.'
            : 'Railway is not authenticated. Run `railway login` and retry.'
    throw new Error(reason)
  }

  const project = await ensureRailwayProject(runner, {
    ...options,
    workspaces: auth.account?.workspaces
  })
  return { runner, project, env: options.env }
}
